module.exports = __webpack_public_path__ + "img/1x1_repeat.c79814be.jpg";